import request from "../utils/request";

export function GET_DocumentList(token, projectId) {
  return request.get(`/Document/List/${projectId}`, null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_Document(token, projectId, formData) {
  return request.post(`/Document/${projectId}`, formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function DELETE_Document(token, documentId) {
  return request.delete(`/Document/${documentId}`, null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_TaskAttachments(token, taskId) {
  return request.get(`/Task/Attachment/List/${taskId}`, null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_TaskAttachment(token, taskId, formData) {
  return request.post(`/Task/Attachment/${taskId}`, formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function DELETE_TaskAttachment(token, attachmentId) {
  return request.delete(`/Task/Attachment/${attachmentId}`, null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
